import * as R from 'ramda'
import {
  ZENDESK_END_USER_AUTHENTICATION_FAILED,
  ZENDESK_END_USER_AUTHENTICATION_SUCCESS,
} from 'actions'

const surveys = (state = {}, action) => {
  switch (action.type) {
    case ZENDESK_END_USER_AUTHENTICATION_FAILED: {
      return R.merge(state, {
        isZendeskEndUserAuthenticationFailed: true,
      })
    }

    case ZENDESK_END_USER_AUTHENTICATION_SUCCESS: {
      return R.merge(state, {
        isZendeskEndUserAuthenticationFailed: false,
      })
    }

    default:
      return state
  }
}

export default surveys



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/pages/surveys/index.js